import * as React from 'react';
import { Panel } from '@common/bw-ui/ui/panel';
import { BackLink } from '@common/bw-ui/ui/back-link';
import { Button } from '@common/bw-ui/ui/button';
import { ShoppingTrolleyIcon } from '@common/bw-ui/icons/ShoppingTrolleyIcon';

export interface EmptyBasketProps {
  onBack: () => void;
  onAddBooking: () => void;
  onAddEvent: () => void;
  onDashboard: () => void;
}

export function EmptyBasket({
  onBack,
  onAddBooking,
  onAddEvent,
  onDashboard,
}: EmptyBasketProps) {
  return (
    <Panel
      data-slot="empty-basket"
      className="tw:lg:col-span-full tw:flex tw:flex-col tw:gap-6 tw:p-4 tw:md:p-6"
    >
      <BackLink data-slot="back" onClick={onBack} />

      <div className="tw:flex tw:flex-col tw:items-center tw:gap-4 tw:py-8 tw:md:py-12">
        <ShoppingTrolleyIcon
          className="tw:w-16 tw:h-16 tw:text-muted"
          aria-hidden="true"
        />

        <div className="tw:text-center">
          <h2 className="tw:text-xl tw:font-medium tw:text-foreground tw:mb-1">
            Your basket is empty
          </h2>
          <p className="tw:text-sm tw:text-muted tw:m-0">
            Add items to your basket to continue
          </p>
        </div>

        <div className="tw:flex tw:flex-wrap tw:justify-center tw:gap-3 tw:mt-2">
          <Button onClick={onAddBooking} data-slot="add-booking-action">
            <i
              className="icon-bookings tw:text-lg tw:leading-[1]"
              aria-hidden="true"
            />
            Add booking
          </Button>
          <Button
            variant="outline"
            onClick={onAddEvent}
            data-slot="add-event-action"
          >
            <i
              className="icon-calendar-view tw:text-lg tw:leading-[1]"
              aria-hidden="true"
            />
            Add event
          </Button>
          <Button
            variant="outline"
            onClick={onDashboard}
            data-slot="dashboard-action"
          >
            <i
              className="icon-dashboard tw:text-lg tw:leading-[1]"
              aria-hidden="true"
            />
            Return to dashboard
          </Button>
        </div>
      </div>
    </Panel>
  );
}
